import { Link } from 'react-router-dom'

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link className={`logo${compact ? ' logo--compact' : ''}`} to="/" aria-label="Kasia Staszewska — strona główna">
      <span className="logo__letters" aria-hidden="true">
        <span>K</span><i className="logo__divider" /><span>S</span>
      </span>
      {!compact && <span className="logo__name">Kasia Staszewska</span>}
    </Link>
  )
}
